/* ***** MODULES ***** */

import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, ModuleWithProviders, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicStorageModule } from '@ionic/storage-angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

const Modules: any = [
  CommonModule,
  IonicModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,

  // Ionic Modules
  IonicStorageModule,

  // Angular Modules
  TranslateModule,

  MatInputModule,
  MatFormFieldModule,
  MatSelectModule,
  MatIconModule,

];

/* ***** ANGULAR PIPES ***** */
import { DateFormatPipe } from './pipes/date-format/date-format.pipe';
import { ShortDateTimePipe } from './pipes/date-format/short-date-time.pipe';
import { FormatPhonePipe } from './pipes/date-format/format-phone.pipe';
import { ArsCurrencyPipe } from './pipes/currency/ars-currency.pipe';


const Pipes = [DateFormatPipe, ShortDateTimePipe, FormatPhonePipe, ArsCurrencyPipe];

const Directives = [ImageZoomDirective];

/* ***** COMPONENTS LOADING ***** */

const LoadingComponents: any = [

];

/* ***** COMPONENTS SHARED ***** */

import { AccountMenuCardComponent } from './shared/components/account-menu-card/account-menu-card.component';
import { AccountSheetComponent } from './shared/components/account-sheet/account-sheet.component';
import { EventRoleChipComponent } from './shared/components/event-role-chip/event-role-chip.component';
import { EventRoleSheetComponent } from './shared/components/event-role-chip/event-role-sheet.component';
import { UserAvatarComponent } from './shared/components/user-avatar/user-avatar.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { ReportCardComponent } from './shared/components/report-card/report-card.component';
import { PaginatorComponent } from './shared/components/paginator/paginator.component';
import { SearchBarComponent } from './shared/components/search-bar/search-bar.component';
import { FilterTabsComponent } from './shared/components/filter-tabs/filter-tabs.component';
import { LoadMoreButtonComponent } from './shared/components/load-more-button/load-more-button.component';
import { MainButtonComponent } from './shared/components/buttons/main-button/main-button.component';
import { SecondaryButtonComponent } from './shared/components/buttons/secondary-button/secondary-button.component';
import { FlatStatComponent } from './shared/components/flat-stat/flat-stat.component';
import { SummaryCardComponent } from './shared/components/summary-card/summary-card.component';
import { TopSellingProductsComponent } from './shared/components/seller/top-selling-products/top-selling-products.component';
import { ProductItemComponent } from './shared/components/seller/product-item/product-item.component';
import { SearchWithFilterComponent } from './shared/components/search-with-filter/search-with-filter.component';
import { TwoTabsSelectorComponent } from './shared/components/two-tabs-selector/two-tabs-selector.component';
import { ImageViewerModalComponent } from './shared/components/modals/image-viewer-modal/image-viewer-modal.component';
import { ImageZoomDirective } from './shared/directives/image-zoom.directive';
import { ProductDetailsModalComponent } from './shared/components/modals/product-details-modal/product-details-modal.component';
import { TicketCardComponent } from './shared/components/tickets/ticket-card/ticket-card.component';
import { DynamicFilterModalComponent } from './shared/components/modals/dynamic-filter-modal/dynamic-filter-modal.component';
import { TicketOptionsModalComponent } from './shared/components/modals/ticket-options-modal/ticket-options-modal.component';
import { ProductOptionsModalComponent } from './shared/components/modals/product-options-modal/product-options-modal.component';
import { EditTicketModalComponent } from './shared/components/modals/edit-ticket-modal/edit-ticket-modal.component';
import { InfoAlertComponent } from './shared/components/info-alert/info-alert.component';
import { ReasonTextareaComponent } from './shared/components/form/reason-textarea/reason-textarea.component';
import { QuantitySelectorComponent } from './shared/components/form/quantity-selector/quantity-selector.component';
import { DeleteTicketModalComponent } from './shared/components/modals/delete-ticket-modal/delete-ticket-modal.component';
import { CustomToastComponent } from './shared/components/custom-toast/custom-toast.component';
import { ConfirmDeleteTicketModalComponent } from './shared/components/modals/confirm-delete-ticket-modal/confirm-delete-ticket-modal.component';
import { ShareTicketModalComponent } from './shared/components/modals/share-ticket-modal/share-ticket-modal.component';
import { ExclusivePromotionalCardComponent } from './shared/components/seller/exclusive-promotional-card/exclusive-promotional-card.component';
import { EmptyStateComponent } from './shared/components/empty-state/empty-state.component';
import { ProductProgressBarComponent } from './shared/components/seller/product-progress-bar/product-progress-bar.component';
import { GenerateCodeModalComponent } from './shared/components/modals/generate-code-modal/generate-code-modal.component';
import { ShareCodeModalComponent } from './shared/components/modals/share-code-modal/share-code-modal.component';
import { SharePromotionalLinkComponent } from './shared/components/modals/share-promotional-link/share-promotional-link.component';
import { PaymentProductModalComponent } from './shared/components/modals/payment-product-modal/payment-product-modal.component';
import { ShareDirectTicketModalComponent } from './shared/components/modals/share-direct-ticket-modal/share-direct-ticket-modal.component';
import { ShareModalComponent } from './shared/components/modals/share-modal/share-modal.component';
import { GenerateTicketModalComponent } from './shared/components/modals/generate-ticket-modal/generate-ticket-modal.component';
import { InputFormComponent } from './shared/components/form/input-form/input-form.component';
import { ConfirmCloneModalComponent } from './shared/components/modals/confirm-clone-modal/confirm-clone-modal.component';
import { ConfirmVentaRapidaCloneModalComponent } from './shared/components/modals/confirm-venta-rapida-clone-modal/confirm-venta-rapida-clone-modal.component';
import { SearchBarInlineComponent } from './shared/components/search-bar-inline/search-bar-inline.component';
import { GenderPickerModalComponent } from './shared/components/modals/gender-picker-modal/gender-picker-modal.component';
import { TopSoldTicketsComponent } from './shared/components/seller/active-events/top-sold-tickets/top-sold-tickets.component';
import { SoldTicketCardComponent } from './shared/components/seller/active-events/sold-ticket-card/sold-ticket-card.component';
import { DashboardToolbarComponent } from './shared/components/dashboard-toolbar/dashboard-toolbar.component';
import { SellerDashboardToolbarComponent } from './shared/components/seller-dashboard-toolbar/seller-dashboard-toolbar.component';
import { SoldReportTicketSkeletonComponent } from './shared/components/skeletons/sold-report-ticket-skeleton/sold-report-ticket-skeleton.component';
import { ShareBirthdayMessageModalComponent } from './shared/components/modals/share-birthday-message-modal/share-birthday-message-modal.component';
import { VersionUpdateModalComponent } from './shared/components/modals/version-update-modal/version-update-modal.component';
import { InAppNotificationComponent } from './shared/components/in-app-notification/in-app-notification.component';
import { ModalHeaderComponent } from './shared/components/modals/modal-header/modal-header.component';
import { TabsLayoutComponent } from './shared/components/tabs-layout/tabs-layout.component';
import { SellerCardSkeletonComponent } from './shared/components/skeletons/seller-card-skeleton/seller-card-skeleton.component';
import { OptionPickerModalComponent } from './shared/components/modals/option-picker-modal/option-picker-modal.component';
import { DismissableInfoBannerComponent } from './shared/components/dismissable-info-banner/dismissable-info-banner.component';
import { UserSearchResultItemComponent } from './shared/components/venta-rapida/search-step/user-search-result-item/user-search-result-item.component';
import { NoResultsCardComponent } from './shared/components/venta-rapida/search-step/no-results-card/no-results-card.component';
import { VentaRapidaSearchStepComponent } from './shared/components/venta-rapida/search-step/venta-rapida-search-step.component';
import { VentaRapidaWizardModalComponent } from './shared/components/modals/venta-rapida-wizard-modal/venta-rapida-wizard-modal.component';
import { DiffusionQrModalComponent } from './shared/components/modals/diffusion-qr-modal/diffusion-qr-modal.component';
import { VentaRapidaInfoModalComponent } from './shared/components/modals/venta-rapida-info-modal/venta-rapida-info-modal.component';
import { VentaRapidaProductCardComponent } from './shared/components/venta-rapida/product-step/venta-rapida-product-card/venta-rapida-product-card.component';
import { VentaRapidaProductStepComponent } from './shared/components/venta-rapida/product-step/venta-rapida-product-step.component';
import { VentaRapidaPriceStepComponent } from './shared/components/venta-rapida/price-step/venta-rapida-price-step.component';
import { StepperComponent } from './shared/components/stepper/stepper.component';
import { EntityHeaderComponent } from './shared/components/entity-header/entity-header.component';
import { DetailRowComponent } from './shared/components/detail-row/detail-row.component';
import { DetailCardComponent } from './shared/components/detail-card/detail-card.component';
import { InfoRowComponent } from './shared/components/info-row/info-row.component';
import { ProfileAvatarComponent } from './shared/components/profile-avatar/profile-avatar.component';
import { SelectableTableComponent } from './shared/components/selectable-table/selectable-table.component';
import { EventRowSellerComponent } from './shared/components/event-row-seller/event-row-seller.component';
import { SalesSplitCardComponent } from './shared/components/sales-split-card/sales-split-card.component';
import { SoldProductShareRowComponent } from './shared/components/sold-product-share-row/sold-product-share-row.component';

const Components: any = [
  UserAvatarComponent,
  AccountMenuCardComponent,
  AccountSheetComponent,
  EventRoleChipComponent,
  EventRoleSheetComponent,
  HeaderComponent,
  ReportCardComponent,
  PaginatorComponent,
  SearchBarComponent,
  FilterTabsComponent,
  LoadMoreButtonComponent,
  MainButtonComponent,
  SecondaryButtonComponent,
  FlatStatComponent,
  SummaryCardComponent,
  TopSellingProductsComponent,
  ProductItemComponent,
  SearchWithFilterComponent,
  TwoTabsSelectorComponent,
  ProductDetailsModalComponent,
  ImageViewerModalComponent,
  TicketCardComponent,
  DynamicFilterModalComponent,
  TicketOptionsModalComponent,
  ProductOptionsModalComponent,
  EditTicketModalComponent,
  InfoAlertComponent,
  ReasonTextareaComponent,
  QuantitySelectorComponent,
  DeleteTicketModalComponent,
  CustomToastComponent,
  ConfirmDeleteTicketModalComponent,
  ShareTicketModalComponent,
  ExclusivePromotionalCardComponent,
  EmptyStateComponent,
  ProductProgressBarComponent,
  GenerateCodeModalComponent,
  ShareCodeModalComponent,
  SharePromotionalLinkComponent,
  PaymentProductModalComponent,
  ShareDirectTicketModalComponent,
  ShareModalComponent,
  GenerateTicketModalComponent,
  InputFormComponent,
  ConfirmCloneModalComponent,
  ConfirmVentaRapidaCloneModalComponent,
  SearchBarInlineComponent,
  GenderPickerModalComponent,
  TopSoldTicketsComponent,
  SoldTicketCardComponent,
  DashboardToolbarComponent,
  SellerDashboardToolbarComponent,
  SoldReportTicketSkeletonComponent,
  ShareBirthdayMessageModalComponent,
  VersionUpdateModalComponent,
  InAppNotificationComponent,
  ModalHeaderComponent,
  TabsLayoutComponent,
  SellerCardSkeletonComponent,
  OptionPickerModalComponent,
  DismissableInfoBannerComponent,
  UserSearchResultItemComponent,
  NoResultsCardComponent,
  VentaRapidaSearchStepComponent,
  VentaRapidaWizardModalComponent,
  VentaRapidaInfoModalComponent,
  DiffusionQrModalComponent,
  VentaRapidaProductCardComponent,
  VentaRapidaProductStepComponent,
  VentaRapidaPriceStepComponent,
  StepperComponent,
  EntityHeaderComponent,
  DetailRowComponent,
  DetailCardComponent,
  InfoRowComponent,
  ProfileAvatarComponent,
  SelectableTableComponent,
  EventRowSellerComponent,
  SalesSplitCardComponent,
  SoldProductShareRowComponent,
];

/* ***** COMPONENTS TO EXPORT ***** */

const EntryComponents: any = [

];

/* ***** ANGULAR SERVICES ***** */

const Services = [];
import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';


@NgModule({
  imports: [
    Modules,
    NgxMaterialIntlTelInputComponent,

  ],
  declarations: [
    Pipes,
    Directives,
    Components
  ],
  exports: [
    Modules,
    Pipes,
    Directives,
    Components,
    NgxMaterialIntlTelInputComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: []
    };
  }
}
